/* refonte-article.js - genere depuis CLEAN-TWIN-ARTICLE.html - NE PAS EDITER A LA MAIN */
(function(){
  var RF = document.getElementById('rf-article') || document;
  function RFid(id){ return RF.querySelector('#' + id); }

  var doc = document.documentElement;
  doc.classList.add('js');
  var rm = matchMedia('(prefers-reduced-motion: reduce)').matches;

  function showAll(){
    RF.querySelectorAll('[data-rv]').forEach(function(n){ n.classList.add('on'); });
  }

  /* 1. Reveal au scroll */
  var io = new IntersectionObserver(function(es){
    es.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('on'); io.unobserve(e.target); } });
  }, {threshold:.08, rootMargin:'0px 0px -40px 0px'});
  RF.querySelectorAll('[data-rv]').forEach(function(n){ io.observe(n); });

  /* Filet de sécurité : onglet caché ou IO inactif, on n'ampute jamais le contenu */
  if(rm || document.visibilityState === 'hidden') showAll();
  addEventListener('visibilitychange', function(){ if(document.visibilityState === 'hidden') showAll(); });
  setTimeout(function(){
    var last = RF.querySelectorAll('[data-rv]');
    if(last.length && !last[0].classList.contains('on')) showAll();
  }, 3000);

  /* 2. Sommaire actif au scroll */
  var links = [].slice.call(RF.querySelectorAll('.toc a[href^="#"]'));
  var map = {};
  var targets = links.map(function(a){
    var el = RFid(a.getAttribute('href').slice(1));
    if(el) map[el.id] = a;
    return el;
  }).filter(Boolean);
  if(targets.length){
    var io3 = new IntersectionObserver(function(es){
      es.forEach(function(e){
        if(!e.isIntersecting) return;
        links.forEach(function(a){ a.classList.remove('on'); });
        if(map[e.target.id]) map[e.target.id].classList.add('on');
      });
    }, {rootMargin:'-80px 0px -70% 0px', threshold:0});
    targets.forEach(function(t){ io3.observe(t); });
  }

  /* 3. Spotlight curseur de l'en-tête (desktop, hors reduced-motion) */
  var ah = RFid('ah');
  if(ah && !rm && matchMedia('(hover: hover)').matches){
    ah.classList.add('spot');
    var raf=0, x=50, y=28;
    ah.addEventListener('mousemove', function(e){
      var r=ah.getBoundingClientRect();
      x=((e.clientX-r.left)/r.width)*100; y=((e.clientY-r.top)/r.height)*100;
      if(!raf) raf=requestAnimationFrame(function(){ ah.style.setProperty('--mx',x+'%'); ah.style.setProperty('--my',y+'%'); raf=0; });
    }, {passive:true});
  }

  /* 4. Sommaire genere depuis le contenu reel de l'article ({{ article.content }}) */
  var zone = RFid('rf-content'), toc = RF.querySelector('.toc'),
      list = toc && toc.querySelector('ol');
  if(zone && list){
    var hs = [].slice.call(zone.querySelectorAll('h2')), n = 0, html = '';
    hs.forEach(function(h){
      var t = (h.textContent || '').trim();
      if(!t) return;
      n++;
      if(!h.id){
        var sl = t.toLowerCase()
          .normalize('NFD').replace(/[̀-ͯ]/g,'')
          .replace(/[^a-z0-9]+/g,'-').replace(/^-+|-+$/g,'').slice(0,60);
        h.id = sl ? (RFid(sl) ? sl + '-' + n : sl) : 'rf-s' + n;
      }
      html += '<li><a href="#' + h.id + '"></a></li>';
    });
    if(n >= 2){
      list.innerHTML = html;
      var as = list.querySelectorAll('a');
      hs.filter(function(h){ return (h.textContent || '').trim(); })
        .forEach(function(h, i){ if(as[i]) as[i].textContent = h.textContent.trim(); });
      toc.removeAttribute('hidden');
    }
  }

  /* 5. Confort de lecture : 1er paragraphe en chapo, tableaux scrollables */
  if(zone){
    var p1 = zone.querySelector('p');
    if(p1) p1.classList.add('intro');
    [].slice.call(zone.querySelectorAll('table')).forEach(function(t){
      if(t.parentNode && t.parentNode.classList.contains('tbl')) return;
      var w = document.createElement('div');
      w.className = 'tbl';
      t.parentNode.insertBefore(w, t);
      w.appendChild(t);
    });
    [].slice.call(zone.querySelectorAll('img')).forEach(function(i){
      i.setAttribute('loading', 'lazy'); i.setAttribute('decoding', 'async');
    });
  }

  /* 6. Sommaire actif : relance apres generation (les cibles n'existaient pas plus haut) */
  var tl = [].slice.call(RF.querySelectorAll('.toc a[href^="#"]'));
  if(tl.length){
    var tmap = {}, tt = [];
    tl.forEach(function(a){
      var el = RFid(a.getAttribute('href').slice(1));
      if(el){ tmap[el.id] = a; tt.push(el); }
    });
    if(tt.length){
      var io4 = new IntersectionObserver(function(es){
        es.forEach(function(e){
          if(!e.isIntersecting) return;
          tl.forEach(function(a){ a.classList.remove('on'); });
          if(tmap[e.target.id]) tmap[e.target.id].classList.add('on');
        });
      }, {rootMargin:'-80px 0px -70% 0px', threshold:0});
      tt.forEach(function(t){ io4.observe(t); });
    }
  }
})();

/* menu mobile */
(function(){
  var hd = document.querySelector('[id^="rf-"] .hd') || document.querySelector('.hd');
  if(!hd) return;
  var b = hd.querySelector('.brg');
  if(!b) return;
  b.addEventListener('click', function(){
    var open = hd.classList.toggle('is-open');
    b.setAttribute('aria-expanded', String(open));
    b.setAttribute('aria-label', open ? 'Fermer le menu' : 'Ouvrir le menu');
  });
  hd.querySelectorAll('.nav a').forEach(function(a){
    a.addEventListener('click', function(){
      hd.classList.remove('is-open'); b.setAttribute('aria-expanded','false');
    });
  });
  document.addEventListener('click', function(e){
    if(hd.classList.contains('is-open') && !hd.contains(e.target)){
      hd.classList.remove('is-open'); b.setAttribute('aria-expanded','false');
    }
  });
})();
